import React from "react";
import CommonReport from "../../../../reports/components/CommonReport";
import { connect } from "react-redux";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from "devextreme-react/button";
import TextArea from 'devextreme-react/text-area';
import { SelectBox } from 'devextreme-react/select-box';
import RadioGroup from 'devextreme-react/radio-group';
import DateBox from 'devextreme-react/date-box';
import { TextBox } from 'devextreme-react/text-box';
import { Lookup, DropDownOptions } from 'devextreme-react/lookup';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Popup from "devextreme-react/popup";
import axios from "axios";
import routes from "../../../../assets/apiRoutes.json";
import Accordion from 'devextreme-react/accordion';
import { alert } from "devextreme/ui/dialog";
import { LoadPanel } from "devextreme-react";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { IDCustomerLookupLayout } from '../../../../common/lookups/Layouts/IdLayouts';
import { ACDepartmentLayout } from '../../../../common/lookups/Layouts/ACLayouts';
import { FAFundLayout } from '../../../../common/lookups/Layouts/FALayouts';
import { CAJobLayout } from '../../../../common/lookups/Layouts/CALayouts';
import DataGrid, { Column, Export, Sorting, FilterRow, Scrolling, Paging, ColumnChooser } from "devextreme-react/data-grid";

const customerLayout = IDCustomerLookupLayout();
const createRangeLayout = (groupLabel, prefix, layout, groupId = 1) => [{
    groupId: groupId,
    label: groupLabel,
    fields: [
        { name: `from${prefix}1`, tableName: "FILTER", label: "From 1", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
        { name: `to${prefix}1`, tableName: "FILTER", label: "To 1", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
        { name: `from${prefix}2`, tableName: "FILTER", label: "From 2", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
        { name: `to${prefix}2`, tableName: "FILTER", label: "To 2", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
        { name: `from${prefix}3`, tableName: "FILTER", label: "From 3", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
        { name: `to${prefix}3`, tableName: "FILTER", label: "To 3", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
        { name: `from${prefix}4`, tableName: "FILTER", label: "From 4", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
        { name: `to${prefix}4`, tableName: "FILTER", label: "To 4", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
        { name: `from${prefix}5`, tableName: "FILTER", label: "From 5", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
        { name: `to${prefix}5`, tableName: "FILTER", label: "To 5", type: "lookup", layout: layout, required: false, visible: true, isLabelChanged: false },
    ]
}];

const PrimaryFilterLayout = [
    ...createRangeLayout("Bill To Customer", "Cust", customerLayout, 1),
    ...createRangeLayout("Department", "Dept", ACDepartmentLayout, 2),
    ...createRangeLayout("Fund", "Fund", FAFundLayout, 3),
    ...createRangeLayout("Job", "Job", CAJobLayout, 4),
];

const searchpanel = [
    {
      ID: 1,
      Name: 'Search Filters'
    }
  ];
  
  let accessToken = "";
  
  class GenerateStorageCharges extends React.Component {
    constructor(props) {
      super(props);
      accessToken = props.oidc.user.access_token;
      this.startButtonClicked = this.startButtonClicked.bind(this);
      this.applyButtonClicked = this.applyButtonClicked.bind(this);
      this.previewButtonClicked = this.previewButtonClicked.bind(this);
      this.resetButtonClicked = this.resetButtonClicked.bind(this);
      this.formRefs = React.createRef();
      this.formRefs.current = {};
      this.setFilterFields = (updater) => {
        this.setState((prevState) => {
          const newFields = typeof updater === 'function' ? updater(prevState.report) : updater;
          return { report: { ...prevState.report, ...newFields } };
        });
      };
      this.handleFilterFieldChange = (name, value) => {
        this.handleChange(name, value);
      };
  
      this.initialState = {
        previewData: null,
        errorsData: null,
        byCustomerData: null,
        byDepartmentData: null,
        applyEnabled: false,
        errorLevelFilter: 'E',
        report: {
          storageTiming: 'A',
          frequencyCode: 'W',
          endDate: new Date(),
          effectiveDate: new Date(),
          transactionDate: new Date(),
          reference: '',
          transactionStatus: 'O',
          rDepartment: null,
          rFund: null,
          rJob: null,
          comment: '',
          fromCust1: '', toCust1: '', fromCust2: '', toCust2: '', fromCust3: '', toCust3: '', fromCust4: '', toCust4: '', fromCust5: '', toCust5: '',
          fromDept1: '', toDept1: '', fromDept2: '', toDept2: '', fromDept3: '', toDept3: '', fromDept4: '', toDept4: '', fromDept5: '', toDept5: '',
          fromFund1: '', toFund1: '', fromFund2: '', toFund2: '', fromFund3: '', toFund3: '', fromFund4: '', toFund4: '', fromFund5: '', toFund5: '',
          fromJob1: '', toJob1: '', fromJob2: '', toJob2: '', fromJob3: '', toJob3: '', fromJob4: '', toJob4: '', fromJob5: '', toJob5: '',
          validateRatesAndCharges: 'F',
          useAsOfDateForEmptyNextBilling: 'A',
          showCalculation: 'Y',
          create0OnHand: 'Y',
          showErrorsForMissedBillings: 'Y',
          showErrorsForAlreadyBilled: 'Y',
          warningOnExcludeCharges: 'Y',
          calculateOnHandBillAsQuantities: 'Y',
          writeSublotQuantitiesToComment: 'Y',
          displayDates: 'Y',
          validateMissingDept: 'N',
          validateMissingJob: 'N',
          validateMissingFund: 'N',
          validateFlags: 'F',
          validateData: 'F',
          filterWhereInfoList: []
        },
        isPreviewGridPopupVisible: false,
        loadIndicatorVisible: false,
        animationDuration: 300,
        selectedItems: searchpanel,
      };
      this.state = { ...this.initialState };

      const buildLookupSource = (url) => new DataSource({
        store: new createStore({
          key: 'id',
          loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
          onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`
            };
          }
        }),
        paginate: true,
        pageSize: 100
      });

      this.departmentDataSource = buildLookupSource('ac/Lookup/GetDepartments');
      this.fundDataSource = buildLookupSource('fa/Lookup/GetFafunds');
      this.jobDataSource = buildLookupSource('ca/Lookup/GetCaJobs');

      this.handleReportStateChange = this.handleReportStateChange.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleClosePreviewPopUpCallback = this.handleClosePreviewPopUpCallback.bind(this);
      this.selectionChanged = this.selectionChanged.bind(this);
    }
  
    handleReportStateChange = (reportState) => {
      this.setState({
        report: reportState
      });
    }
  
    handleChange = (field, value) => {
      this.setState((prevState) => ({
        report: {
          ...prevState.report,
          [field]: value
        }
      }));
    }
  
    handleClosePreviewPopUpCallback = () => {
      this.setState({ isPreviewGridPopupVisible: false });
    }
  
    selectionChanged = (e) => {
      let newItems = [...this.state.selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      this.setState({
        selectedItems: newItems
      });
    }
  
    startButtonClicked = async (e) => {
      if (e?.event)
        e.event.stopPropagation();
      this.setState({
        loadIndicatorVisible: true,
      });
  
      try {
        const response = await this.transferDeliveries();
        console.log(response)
        this.setState({ loadIndicatorVisible: false, applyEnabled: true });
        if (response.errors > 0) {
          alert("The State Change Process generated  " + response.errors + "  error message(s).", "Error");
        }
        alert("Records Processed:  " + response, "Process Complete");

      } catch (error) {
        console.error('Error:', error);
        alert("Error: " + error.message, "Error");
      }
      finally {
        this.setState({ loadIndicatorVisible: false });
      }
    };
    applyButtonClicked = async (e) => {
      if (e?.event)
        e.event.stopPropagation();
      this.setState({ loadIndicatorVisible: true });
      try {
        const res = await axios.post(
          `${window._env_.REACT_APP_APIS}/wm/TransactionCharge/ApplyStorageCharges`,
          JSON.stringify(this.state.report),
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        const result = res.data;
        alert(
          "Batch: " + (result.Batch || result.batch || 0) +
          "\nHeaders Created: " + (result.HeadersCreated || result.headersCreated || 0) +
          "\nDetails Created: " + (result.DetailsCreated || result.detailsCreated || 0) +
          "\nCharges Created: " + (result.ChargesCreated || result.chargesCreated || 0),
          "Apply Complete"
        );
      } catch (error) {
        console.error('Error:', error);
        alert("Error: " + (error?.response?.data || error.message), "Error");
      } finally {
        this.setState({ loadIndicatorVisible: false });
      }
    };
    errorLevelChanged = async (e) => {
      const newLevel = e.value;
      this.setState({ errorLevelFilter: newLevel, loadIndicatorVisible: true });
      const errorsData = await this.ErrorsData(newLevel);
      this.setState({ errorsData: errorsData, loadIndicatorVisible: false });
    };
    transferDeliveries = async () => {
      try {
        const filterWhereInfoList = this.state.report?.filterWhereInfoList || [];
  
        await this.setState((prevState) => ({
          transferDeliveriesParams: {
            ...prevState.report,
            ['filterWhereInfoList']: filterWhereInfoList,
            ['storageTiming']: prevState.report.storageTiming
          }
        }));
        // Make the POST request to the API endpoint
        const res = await axios.post(
          `${window._env_.REACT_APP_APIS}/${routes.Transaction.GenerateStorageCharges}`,
          JSON.stringify(this.state.report),
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        return res.data; // Return the response data
      } catch (error) {
        this.setState({
          loadIndicatorVisible: false
        });
        console.error('Error:', error);
        throw error; // Re-throw the error for handling in the component
      }
    };
    PreviewData = async () => {
      try {
        const res = await axios.get(
          `${window._env_.REACT_APP_APIS}/wm/Sbprocess/GetSbprocesses`,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        return res.data?.data || res.data;
      } catch (error) {
        this.setState({
          loadIndicatorVisible: false
        });
        console.error('Error:', error);
        throw error;
      }
    };
    ErrorsData = async (errorLevel = 'E') => {
      try {
        const res = await axios.get(
          `${window._env_.REACT_APP_APIS}/wm/SbProcessErrors/GetSbProcessErrors?errorLevel=${errorLevel}`,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        return res.data?.data || res.data;
      } catch (error) {
        console.error('Error:', error);
        return [];
      }
    };
    ByCustomerData = async () => {
      try {
        const res = await axios.get(
          `${window._env_.REACT_APP_APIS}/wm/SbProcessErrors/GetErrorsByCustomer`,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        return Array.isArray(res.data) ? res.data : (res.data?.data || []);
      } catch (error) {
        console.error('Error:', error);
        return [];
      }
    };
    ByDepartmentData = async () => {
      try {
        const res = await axios.get(
          `${window._env_.REACT_APP_APIS}/wm/SbProcessErrors/GetErrorsByDepartment`,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        return Array.isArray(res.data) ? res.data : (res.data?.data || []);
      } catch (error) {
        console.error('Error:', error);
        return [];
      }
    };
  
    async previewButtonClicked(e) {
      if (e?.event)
        e.event.stopPropagation();
      this.setState({
        loadIndicatorVisible: true
      });
      const [data, errorsData, byCustomerData, byDepartmentData] = await Promise.all([this.PreviewData(), this.ErrorsData(this.state.errorLevelFilter), this.ByCustomerData(), this.ByDepartmentData()]);
      this.setState({
        previewData: data,
        errorsData: errorsData,
        byCustomerData: byCustomerData,
        byDepartmentData: byDepartmentData,
        isPreviewGridPopupVisible: true,
        loadIndicatorVisible: false
      });
    }
    resetButtonClicked(e) {
      if (e?.event)
        e.event.stopPropagation();
      this.setState({ ...this.initialState });
    }
  
  
    render() {
      return (
        <>
          <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            onHiding={(() => this.setState({ loadIndicatorVisible: false }))}
            visible={this.state.loadIndicatorVisible}
            showIndicator={true}
            shading={true}
            showPane={true}
            hideOnOutsideClick={false}
          />
          <div className="row">
            <div className="col-md-12 main-page">
              <div id="accordion" >
                <Accordion
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={false}
                  animationDuration={this.state.animationDuration}
                  selectedItems={this.state.selectedItems}
                  onSelectionChanged={this.selectionChanged}
                  itemTitleRender={() => (
  
                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                        <div className="title">
                          <h6
                            style={{
                              color: window._env_.Color2
                            }}
                          >
                            Generate Storage Charges
                          </h6>
                        </div>
                      </Item>
  
                      <Item location="after">
                        <Button className="accordianButton" text="Apply" onClick={this.applyButtonClicked} disabled={!this.state.applyEnabled} type="default" />
                      </Item>
                      <Item location="after">
                        <Button className="accordianButton" text="Start" onClick={this.startButtonClicked} type="default" />
                      </Item>
                      <Item location="after">
                        <Button className="accordianButton" onClick={this.previewButtonClicked} text="Preview" />
                      </Item>
                      <Item location="after">
                        <Button className="accordianButton" onClick={this.resetButtonClicked} text="Reset" />
                      </Item>
                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    <div>
                      <TabPanel height="auto">
                        <TabItem title="Data Selector">
                          <div className="row" style={{ padding: '10px' }}>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.storageTiming} dataSource={[{ id: 'A', name: 'Bill Ahead' }, { id: 'B', name: 'Bill Behind' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Timing" onValueChanged={(e) => this.handleChange('storageTiming', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.frequencyCode} dataSource={[{ id: 'W', name: 'Last Day of Week [Saturday]' }, { id: 'M', name: 'Last Day of the Month' }, { id: 'S', name: 'Last Day of Semi-Monthly [15th + Last Day]' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Frequency" onValueChanged={(e) => this.handleChange('frequencyCode', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <DateBox value={this.state.report.endDate} type="date" stylingMode='outlined' labelMode="static" label="End Date" onValueChanged={(e) => this.handleChange('endDate', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <DateBox value={this.state.report.effectiveDate} type="date" stylingMode='outlined' labelMode="static" label="Effective Date" onValueChanged={(e) => this.handleChange('effectiveDate', e.value)} />
                            </div>
                          </div>
                          <div className="row" style={{ padding: '0px 10px 10px 10px' }}>
                            <div className="col-md-3">
                              <DateBox value={this.state.report.transactionDate} type="date" stylingMode='outlined' labelMode="static" label="Transaction Date" onValueChanged={(e) => this.handleChange('transactionDate', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <TextBox value={this.state.report.reference} stylingMode='outlined' labelMode="static" label="Reference" onValueChanged={(e) => this.handleChange('reference', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.transactionStatus} dataSource={[{ id: 'O', name: 'Open' }, { id: 'C', name: 'Close' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Transaction Status" onValueChanged={(e) => this.handleChange('transactionStatus', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <Lookup dataSource={this.departmentDataSource} value={this.state.report.rDepartment} valueExpr="id" displayExpr="name" searchEnabled={true} showClearButton={true} stylingMode='outlined' labelMode="static" label="Department" onValueChanged={(e) => this.handleChange('rDepartment', e.value)}><DropDownOptions showTitle={false} /></Lookup>
                            </div>
                          </div>
                          <div className="row" style={{ padding: '0px 10px 10px 10px' }}>
                            <div className="col-md-3">
                              <Lookup dataSource={this.fundDataSource} value={this.state.report.rFund} valueExpr="id" displayExpr="name" searchEnabled={true} showClearButton={true} stylingMode='outlined' labelMode="static" label="FA Fund" onValueChanged={(e) => this.handleChange('rFund', e.value)}><DropDownOptions showTitle={false} /></Lookup>
                            </div>
                            <div className="col-md-3">
                              <Lookup dataSource={this.jobDataSource} value={this.state.report.rJob} valueExpr="id" displayExpr="name" searchEnabled={true} showClearButton={true} stylingMode='outlined' labelMode="static" label="CA Job" onValueChanged={(e) => this.handleChange('rJob', e.value)}><DropDownOptions showTitle={false} /></Lookup>
                            </div>
                            <div className="col-md-3">
                              <TextBox value={this.state.report.comment} stylingMode='outlined' labelMode="static" label="Comment" onValueChanged={(e) => this.handleChange('comment', e.value)} />
                            </div>
                          </div>
                        </TabItem>
                        <TabItem title="Primary Filters">
                          <FormField
                            currrentUser={this.props.oidc.user}
                            layoutId='6712abab-afbb-483a-a85f-cacc4f514063'
                            layoutName='GSCPrimaryFilters'
                            defaultFormSchema={PrimaryFilterLayout}
                            formFields={this.state.report}
                            setformFields={this.setFilterFields}
                            handleFieldValueChange={this.handleFilterFieldChange}
                            DYNAMICFORMSETTING={this.props.oidc?.user?.profile?.DYNAMICFORMSETTING}
                            formRefs={this.formRefs}
                            onFormLoad={() => {}}
                          />
                        </TabItem>
                        <TabItem title="Options">
                          <div className="row" style={{ padding: '10px' }}>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.validateRatesAndCharges} dataSource={[{ id: 'F', name: 'Validate and Exclude Charges with Errors' }, { id: 'S', name: 'Validate and STOP Process if errors are Found' }, { id: 'N', name: 'Do Not Validate' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Rate Charges" onValueChanged={(e) => this.handleChange('validateRatesAndCharges', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.useAsOfDateForEmptyNextBilling} dataSource={[{ id: 'A', name: 'Override "Next Billing Date" in Item/Lot with "As Of Date"' }, { id: 'S', name: 'Use Standard "Next Billing Date" calculation method' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Next Billing Date" onValueChanged={(e) => this.handleChange('useAsOfDateForEmptyNextBilling', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.showCalculation} dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Show Calculation Details" onValueChanged={(e) => this.handleChange('showCalculation', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.create0OnHand} dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Zero On Hand Warnings" onValueChanged={(e) => this.handleChange('create0OnHand', e.value)} />
                            </div>
                          </div>
                          <div className="row" style={{ padding: '0px 10px 10px 10px' }}>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.showErrorsForMissedBillings} dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Show Missed Billings Messages" onValueChanged={(e) => this.handleChange('showErrorsForMissedBillings', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.showErrorsForAlreadyBilled} dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Show Already Billed Messages" onValueChanged={(e) => this.handleChange('showErrorsForAlreadyBilled', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.warningOnExcludeCharges} dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Show Excluded Items" onValueChanged={(e) => this.handleChange('warningOnExcludeCharges', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.calculateOnHandBillAsQuantities} dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Calc Sublot Quantities" onValueChanged={(e) => this.handleChange('calculateOnHandBillAsQuantities', e.value)} />
                            </div>
                          </div>
                          <div className="row" style={{ padding: '0px 10px 10px 10px' }}>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.writeSublotQuantitiesToComment} dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Display Sublots" onValueChanged={(e) => this.handleChange('writeSublotQuantitiesToComment', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.displayDates} dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Display Dates" onValueChanged={(e) => this.handleChange('displayDates', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.validateMissingDept} dataSource={[{ id: 'Y', name: 'Yes, Warning Only' }, { id: 'E', name: 'Yes, Warning and Exclude' }, { id: 'N', name: 'No, Do Not Validate' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Validate Missing Dept" onValueChanged={(e) => this.handleChange('validateMissingDept', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.validateMissingJob} dataSource={[{ id: 'Y', name: 'Yes, Warning Only' }, { id: 'E', name: 'Yes, Warning and Exclude' }, { id: 'N', name: 'No, Do Not Validate' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Validate Missing Job" onValueChanged={(e) => this.handleChange('validateMissingJob', e.value)} />
                            </div>
                          </div>
                          <div className="row" style={{ padding: '0px 10px 10px 10px' }}>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.validateMissingFund} dataSource={[{ id: 'Y', name: 'Yes, Warning Only' }, { id: 'E', name: 'Yes, Warning and Exclude' }, { id: 'N', name: 'No, Do Not Validate' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Validate Missing Fund" onValueChanged={(e) => this.handleChange('validateMissingFund', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.validateFlags} dataSource={[{ id: 'F', name: 'All' }, { id: 'A', name: 'Active Only' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Customer Status" onValueChanged={(e) => this.handleChange('validateFlags', e.value)} />
                            </div>
                            <div className="col-md-3">
                              <SelectBox value={this.state.report.validateData} dataSource={[{ id: 'F', name: 'All' }, { id: 'A', name: 'Active Only' }]} valueExpr="id" displayExpr="name" stylingMode='outlined' labelMode="static" label="Inventory Status" onValueChanged={(e) => this.handleChange('validateData', e.value)} />
                            </div>
                          </div>
                        </TabItem>
                      </TabPanel>
                    </div>
                  )}
                  id="accordion-container" className="accordion-height"
                />
              </div>
            </div>
          </div>
          <CommonReport
            name="WMGenerateStorageCharges"
            fullName="WMGenerateStorageCharges"
            state={this.state}
            onReportStateChange={this.handleReportStateChange}
          />
          {this.state.isPreviewGridPopupVisible &&
            <Popup
              visible={this.state.isPreviewGridPopupVisible}
              onHiding={this.handleClosePreviewPopUpCallback}
              dragEnabled={true}
              hideOnOutsideClick={true}
              showCloseButton={true}
              showTitle={true}
              title={"Preview"}
              container=".dx-viewport"
              width="95%"
              height="80%"
            >
              <TabPanel height="100%">
                <TabItem title="Preview Charges">
                  <DataGrid
                    dataSource={this.state.previewData}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    height="calc(100% - 141px)"
                  >
                    <Sorting mode="multiple" />
                    <FilterRow visible={true} />
                    <Scrolling mode="virtual" rowRenderingMode="virtual" />
                    <Paging enabled={true} pageSize={50} />
                    <Export enabled={true} />
                    <ColumnChooser enabled={true} />
                    <Column dataField="BillingIdentityid" caption="Bill To Customer" />
                    <Column dataField="ItemItemcode" caption="Item" />
                    <Column dataField="LotLotcode" caption="Lot" />
                    <Column dataField="SublotSublotcode" caption="Sublot" />
                    <Column dataField="Billasquantity" caption="Bill As Quantity" dataType="number" />
                    <Column dataField="Unitrate" caption="Unit Rate" dataType="number" />
                    <Column dataField="Amount" caption="Amount" dataType="number" />
                    <Column dataField="Description" caption="Account Description" />
                    <Column dataField="Detailstoragestartdate" caption="Storage Start" dataType="date" />
                    <Column dataField="Detailstorageenddate" caption="Storage End" dataType="date" />
                    <Column dataField="Chargebasislevel" caption="Charge Basis Level" visible={false} />
                    <Column dataField="Chargetiming" caption="Charge Timing" visible={false} />
                    <Column dataField="Chargeuom" caption="Charge UOM" visible={false} />
                    <Column dataField="Companyid" caption="Company ID" visible={false} />
                    <Column dataField="Billasquantitystart" caption="Bill As Qty at Start" dataType="number" visible={false} />
                    <Column dataField="Billasquantityperiod" caption="Bill As Qty During Period" dataType="number" visible={false} />
                    <Column dataField="Detailgrossweight" caption="Detail Gross Wt" dataType="number" visible={false} />
                    <Column dataField="Detailnetweight" caption="Detail Net Wt" dataType="number" visible={false} />
                    <Column dataField="CustomerIdentityid" caption="Customer" visible={false} />
                  </DataGrid>
                </TabItem>
                <TabItem title="Errors">
                  <div style={{ padding: '8px 10px' }}>
                    <RadioGroup
                      items={[{ id: 'E', name: 'Error' }, { id: 'W', name: 'Warning' }]}
                      valueExpr="id"
                      displayExpr="name"
                      value={this.state.errorLevelFilter}
                      layout="horizontal"
                      onValueChanged={this.errorLevelChanged}
                    />
                  </div>
                  <DataGrid
                    dataSource={this.state.errorsData}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    height="calc(100% - 141px)"
                  >
                    <Sorting mode="multiple" />
                    <FilterRow visible={true} />
                    <Scrolling mode="virtual" rowRenderingMode="virtual" />
                    <Paging enabled={true} pageSize={50} />
                    <Export enabled={true} />
                    <ColumnChooser enabled={true} />
                    <Column dataField="ErrorLevel" caption="Error Level" />
                    <Column dataField="ShortMessage" caption="Short Message" />
                    <Column dataField="CustomerIdentityId" caption="Customer" />
                    <Column dataField="ItemItemCode" caption="Item" />
                    <Column dataField="LotLotCode" caption="Lot" />
                    <Column dataField="SublotSublotCode" caption="Sublot" />
                    <Column dataField="ChargesChargeBasisLevel" caption="Charge" visible={false} />
                    <Column dataField="ChargesChargeBasisLevel" caption="Charge Basis Level" visible={false} />
                    <Column dataField="Code" caption="Code" visible={false} />
                    <Column dataField="EffectiveDate" caption="Effective Date" dataType="date" visible={false} />
                    <Column dataField="ItemItemType" caption="Item Type" visible={false} />
                    <Column dataField="ScheduleCode" caption="Schedule Code" visible={false} />
                    <Column dataField="Seq" caption="Sequence" dataType="number" visible={false} />
                    <Column dataField="Source" caption="Source" visible={false} />
                    <Column dataField="ChargeCode" caption="Charge Code" visible={false} />
                    <Column dataField="LongMessage" caption="Long Message" visible={false} />
                  </DataGrid>
                </TabItem>
                <TabItem title="By Customer">
                  <DataGrid
                    dataSource={this.state.byCustomerData}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    height="calc(100% - 141px)"
                  >
                    <Sorting mode="multiple" />
                    <FilterRow visible={true} />
                    <Scrolling mode="virtual" rowRenderingMode="virtual" />
                    <Paging enabled={true} pageSize={50} />
                    <Export enabled={true} />
                    <ColumnChooser enabled={true} />
                    <Column dataField="BillingID" caption="Bill To Customer" />
                    <Column dataField="TotalAmount" caption="Total Amount" dataType="number" format={{ type: 'fixedPoint', precision: 2 }} />
                    <Column dataField="TotalBillAsQuantity" caption="Total Bill As Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2 }} />
                    <Column dataField="TotalChargesCount" caption="Total Charges" dataType="number" />
                    <Column dataField="Errors" caption="Errors" dataType="number" />
                    <Column dataField="Warnings" caption="Warnings" dataType="number" />
                  </DataGrid>
                </TabItem>
                <TabItem title="By Department">
                  <DataGrid
                    dataSource={this.state.byDepartmentData}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    height="calc(100% - 141px)"
                  >
                    <Sorting mode="multiple" />
                    <FilterRow visible={true} />
                    <Scrolling mode="virtual" rowRenderingMode="virtual" />
                    <Paging enabled={true} pageSize={50} />
                    <Export enabled={true} />
                    <ColumnChooser enabled={true} />
                    <Column dataField="Department" caption="Department" />
                    <Column dataField="Description" caption="Description" />
                    <Column dataField="TotalAmount" caption="Total Amount" dataType="number" format={{ type: 'fixedPoint', precision: 2 }} />
                    <Column dataField="TotalBillAsQuantity" caption="Total Bill As Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2 }} />
                    <Column dataField="TotalChargesCount" caption="Total Charges" dataType="number" />
                  </DataGrid>
                </TabItem>
              </TabPanel>
            </Popup>
          }
        </>
      );
    }
  
  }
  
  function mapStateToProps(state) {
    return {
      ReceiptReducer: state.ReceiptReducer,
      oidc: state.oidc,
    };
  }
  
export default connect(mapStateToProps)(GenerateStorageCharges);
 
